var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('msw-app-title',{attrs:{"name":"mswApptitle","v-bind":Object.assign({}, _vm.pageTitleConfig)}}),_vm._v(" "),_c('div',{class:[(_vm.cssPrefix + "__main")]},[_c('showquotedetails')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }